<template>
  <v-card height="100%" id="contractor-vehicles" tile>
    <v-card-title>
      <v-toolbar flat>
        <v-app-bar-nav-icon @click.prevent="$router.back()">
          <v-icon>chevron_left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>
          <v-row>
            <v-col>
              {{ resx.labels.vehicles }}
              <span v-if="contractorCompany && contractorCompany.contractor">{{
                `${contractorCompany.contractor.name}`
              }}</span>
            </v-col>
            <v-col>
              <v-text-field
                append-icon="search"
                :label="resx.labels.search"
                single-line
                hide-details
                v-model="filters.search"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <contractor-sections current="vehicles">
      <notes-panel
        v-if="isSystemUser && contractorCompany._id"
        :contractor-id="contractorCompany._id"
        scope="vehicles"
        :value="contractorCompany.notes ? contractorCompany.notes.vehicles : ''"
        :size="contractorCompany.notesSize ? contractorCompany.notesSize.vehicles : null"
      >
      </notes-panel>
    </contractor-sections>
    <v-card-text class="fixed-header">
      <v-row column fill-height>
        <v-col fill-height class="scrollable">
          <v-data-table
            :headers="headers"
            :items="vehicles"
            :no-data-text="resx.messages.noVehiclesAvailable"
            :no-results-text="resx.messages.noVehiclesFound"
            primary
            hide-details
            item-key="_id"
            sort-by="uniqueIdentifier"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            :search="filters.search"
            :item-class="rowClass"
          >
            <template v-slot:item.hasDelayed="{ item }">
              <td class="layout justify-center align-center px-0">
                <v-tooltip bottom v-if="item.isExcluded">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="grey">block</v-icon>
                  </template>
                  {{ resx.messages.excludedFromAptitude }}
                </v-tooltip>
                <v-tooltip bottom v-else-if="item.hasDelayed">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="error">error</v-icon>
                  </template>
                  {{ resx.messages.hasDelayedObligations }}
                </v-tooltip>
                <v-icon v-else color="success">check_circle</v-icon>
              </td>
            </template>
            <template v-slot:item.description="{ item }">
              <td>{{ item.description }}</td>
            </template>
            <template v-slot:item.type.name="{ item }">
              <td class="hidden-xs-only">
                {{ item.type ? item.type.name : "" }}
              </td>
            </template>
            <template v-slot:item.uniqueIdientifier="{ item }">
              <td class="hidden-xs-only">{{ item.uniqueIdentifier }}</td>
            </template>
            <template v-slot:item.comments="{ item }">
              <td class="hidden-xs-only">
                {{
                  item.comments && item.comments.length > 50
                    ? `${item.comments.substring(0, 50)}...`
                    : item.comments
                }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <div class="d-flex align-center justify-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="manageObligations(item)">
                      <v-icon :color="item.hasDelayed ? 'error' : 'primary'">description</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ resx.labels.obligations }}</span>
                </v-tooltip>
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openVehicleDialog(item)">
                      <v-list-item-action>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.edit
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="toggleExclusion(item)">
                      <v-list-item-action>
                        <v-icon v-if="item.isExcluded" color="primary">check_circle_outline</v-icon>
                        <v-icon v-else color="grey darken-1">block</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        item.isExcluded ? resx.labels.enableVehicle : resx.labels.excludeVehicle
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="remove(item)">
                      <v-list-item-action>
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.delete
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="openVehicleDialog()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-row> </v-row>
      <v-row>
        <edit-vehicles
          v-model="openDialog"
          v-on:close="onClose"
          v-on:save="onSave"
        ></edit-vehicles>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";
import roles from "@/utils/roles";

import contractorCompanyService from "@/services/ContractorCompanyService";

import editVehicles from "../../vehicles/edit-vehicles.view.vue";
import notesPanel from "../notes-panel.vue";
import contractorSections from "../contractor-sections.component.vue";

export default {
  async mounted() {
    this.contractorCompany = await contractorCompanyService.getById(
      this.$route.params.id
    );
    this.setVehicles(
      await contractorCompanyService.getVehicles(this.$route.params.id)
    );
  },
  computed: {
    // Las notas son del personal del sistema.
    isSystemUser() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.ALL_SYS_ROLES
      );
    },
    contractorName() {
      return this.contractor ? this.contractor.name : ``;
    }
  },
  components: {
    editVehicles,
    notesPanel,
    contractorSections
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      contractorCompany: {},
      vehicles: [],
      filters: {
        search: null
      },
      headers: [
        {
          align: "center",
          sortable: false,
          value: "hasDelayed"
        },
        {
          text: resx.labels.description,
          value: "description"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.vehiclesType,
          value: "type.name"
        },
        {
          class: "hidden-xs-only",
          text: resx.labels.uniqueIdentifier,
          value: "uniqueIdentifier",
          filter: this.uniqueIdentifierFilter
        },
        {
          class: "hidden",
          text: "stripped Unique Identifier",
          value: "strippedUniqueIdentifier",
        },
        {
          class: "hidden-xs-only",
          sortable: false,
          text: resx.labels.comments,
          value: "comments"
        },
        {
          align: "center",
          text: resx.labels.actions,
          sortable: false,
          value: "actions"
        }
      ],
      openDialog: null
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    // Toda lista que vuelve del servidor pasa por aca: el campo derivado del
    // buscador (strippedUniqueIdentifier) se calcula en un solo lugar.
    setVehicles(vehicles) {
      vehicles.forEach(vehicle => {
        vehicle.strippedUniqueIdentifier = vehicle.uniqueIdentifier.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").replaceAll(" ", "").replaceAll("-", "");
      });
      this.vehicles = vehicles;
    },
    rowClass(item) {
      return item.isExcluded ? "excluded-row" : "";
    },
    // Excluir / habilitar para el analisis de aptitud. Mientras esta excluido,
    // la fila se ve gris y sus obligaciones no cuentan; se puede volver a
    // habilitar desde este mismo menu.
    async toggleExclusion(vehicle) {
      const contractorCompany = await contractorCompanyService.setVehicleExclusion(
        this.contractorCompany._id,
        vehicle._id,
        !vehicle.isExcluded
      );
      if (contractorCompany) {
        this.setVehicles(contractorCompany.vehicles);
      }
    },
    async remove(item) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.vehicles.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteVehicleMessage,
          item.description
        )
      });

      const contractorCompany = await contractorCompanyService.deleteVehicle(
        this.contractorCompany._id,
        item
      );
      if (contractorCompany) {
        this.setVehicles(contractorCompany.vehicles);
      }
    },
    async onSave(result) {
      const contractorCompany = result.isNew
        ? await contractorCompanyService.addVehicle(
            this.contractorCompany._id,
            result.item
          )
        : await contractorCompanyService.editVehicle(
            this.contractorCompany._id,
            result.item
          );
      if (contractorCompany) {
        this.setVehicles(contractorCompany.vehicles);
      }
      this.onClose();
    },
    onClose() {
      this.openDialog = false;
    },
    manageObligations(vehicle) {
      this.$router.push(
        `/contractors/${this.contractorCompany._id}/vehicles/${vehicle._id}/obligations`
      );
    },
    openVehicleDialog(vehicle) {
      let selectedItem = vehicle ? vehicle : {};
      selectedItem.contractorId = this.contractorCompany._id;
      this.openDialog = { selectedItem };
    },
    uniqueIdentifierFilter(uniqueIdentifier) {
      let filterText = this.filters.search;
      if (!filterText) {
        return true;
      }
      filterText = filterText.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").replaceAll(" ", "").replaceAll("-", "");
      const re = new RegExp(filterText, "i");
      return re.test(uniqueIdentifier.toString().normalize('NFD').replaceAll(/[\u0300-\u036f]/g, ""))
        || re.test(uniqueIdentifier.replaceAll(" ", "").replaceAll("-", ""));
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.filters.search) {
        return true;
      }

      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .replace(/\s/g, "")
        .toLowerCase()
        .includes(this.filters.search.toLowerCase());
    }
  },
  mixins: []
};
</script>

<style lang="scss">
#contractor-vehicles {
  // Vehiculo excluido del analisis de aptitud: la fila queda gris pero el
  // menu de los tres puntos sigue activo para volver a habilitarlo.
  tr.excluded-row {
    background-color: rgba(0, 0, 0, 0.04);
    td {
      color: rgba(0, 0, 0, 0.38);
    }
  }

  .theme--light.v-data-table {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }

  .v-data-table table tbody tr td:nth-child(5) {
    display: none;
  }

  .hidden {
    display: none;
  }
}

.v-toolbar__title {
  width: 100%;
}

.icon {
  cursor: pointer;
}
</style>
